<template>
    <span class="ah-select-project">
        <el-select
            v-model="inputVal"
            filterable
            remote
            :remote-method="remoteMethod"
            reserve-keyword
            :placeholder="companyInfo.displayProject ? '請選擇專案' : '請輸入專案名稱關鍵字（至少兩個字）'"
            :no-data-text="companyInfo.displayProject ? '無專案' : '無匹配專案'"
            :loading="isLoading"
            loading-text="搜尋中"
            no-match-text="沒有匹配的專案"
            @change="handleSelectChange"
            @blur="handleBlur"
        >
            <el-option v-for="item in options" :key="item.sno" :label="item.nam" :value="item.sno" class="ah-select-project-option-item">
                <div class="project-name">
                    <span class="category"
                        ><span class="category-label">{{ item.pjcaT_NAM }}</span></span
                    >
                    <span class="name">{{ item.nam }}</span>
                    <span class="poo">{{ item.poo }}</span>
                </div>
                <div class="vender-name">
                    <span class="name">{{ item.vdR_NAM }}</span>
                </div>
            </el-option>
        </el-select>
    </span>
</template>
<script>
export default {
    name: 'ah-select-project',
    props: {
        value: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data() {
        return {
            isLoading: false,
            options: [],
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        companyInfo() {
            return this.$store.getters['menu/companyInfo'];
        },
    },
    mounted() {
        this.fetchProjectOptions();
    },
    methods: {
        async fetchProjectOptions(init, query) {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: '/InvoiceManagemnetPage/GetProjectList',
                    method: 'GET',
                    params: { PageNum: 1, PageSize: 999, keyword: query },
                });
                if (init) this.options = resp.data.items.filter((o) => o.sno === this.value);
                else this.options = resp.data.items;
            } finally {
                this.isLoading = false;
            }
        },
        remoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.fetchProjectOptions(false, query);
        },
        getTrimmedQuery(str) {
            return str
                .split('')
                .filter((c) => c !== ' ')
                .join('');
        },
        handleSelectChange(project) {
            this.$emit('change', project);
        },
        handleBlur() {
            this.$emit('blur');
        },
    },
};
</script>
<style lang="scss">
.ah-select-project {
    .el-input > input {
        width: 400px;
        cursor: text;
    }
}

.ah-select-project-option-item.el-select-dropdown__item {
    padding-top: 5px;
    height: 70px;
    border-bottom: 1px solid #eee;
    color: #444;

    .project-name {
        display: table;
        width: 100%;

        > .category {
            display: table-cell;
            width: 1px;
            vertical-align: top;
        }

        > .name {
            display: table-cell;
            vertical-align: top;
        }

        > .poo {
            display: table-cell;
            vertical-align: top;
            text-align: right;
            padding: 0 0 0 20px;
            opacity: 0.5;
        }
    }

    .category-label {
        display: inline-block;
        background-color: #eee;
        padding: 4px 5px;
        border-radius: 4px;
        margin: 0 5px 0 0;
        line-height: 100%;
        font-size: 10pt;
    }

    .vender-name {
        font-size: 10pt;
        line-height: 20px;
        opacity: 0.5;
    }

    .poo {
        font-size: 9pt;
        margin: 0 5px 0 0;
    }
}
</style>
